import {
    getWorkoutUrlForRequest,
    getById,
    getWorkoutStockImage,
    uploadWorkoutImage,
    createWorkout,
    getPlannedWorkouts,
    getWorkoutOfTheDayByDateRange,
    getWorkoutOfTheWeek,
    addWorkoutOfTheDay,
    addWorkoutOfTheWeek,
} from './requestConfigs';

class WorkoutApi {
    getWorkoutStockImage = getWorkoutStockImage;
    uploadWorkoutImage = uploadWorkoutImage;
    createWorkout = createWorkout;
    getPlannedWorkouts = getPlannedWorkouts;
    getWorkoutOfTheDayByDateRange = getWorkoutOfTheDayByDateRange;
    addWorkoutOfTheDay = addWorkoutOfTheDay;
    getWorkoutOfTheWeek = getWorkoutOfTheWeek;
    addWorkoutOfTheWeek = addWorkoutOfTheWeek;
    getById = getById;
    workoutSearchRequest = getWorkoutUrlForRequest;
}

class WorkoutApiFactory {
    workout = WorkoutApi;
    create() {
        return new this.workout();
    }
}

export const workout = new WorkoutApiFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/WorkoutApi/index.js